export * from './clientResourceRate.service';
import { ClientResourceRateService } from './clientResourceRate.service';
export * from './rateDetails.service';
import { RateDetailsService } from './rateDetails.service';
export * from './rates.service';
import { RatesService } from './rates.service';
export const APIS = [ClientResourceRateService, RateDetailsService, RatesService];
